<template>
  <div>
    <p class="no_data" v-if="!customerTrailList.length">暂无数据~</p>
    <!--    时间轴-->
    <div class="timeline_box">
      <a-timeline mode="right" class="timeline_left" >
        <a-timeline-item color="red" class="line_item" v-for="(item,index) in customerTrailList" :key="index">
          <span class="time">{{item.trajectoryDate}}</span>
        </a-timeline-item>
      </a-timeline>

      <a-timeline class="timeline_right">
        <a-timeline-item color="red" class="line_item fix" v-for="(item,index) in customerTrailList" :key="index">
          <div class="things_box l">
            <span class="words_item">{{item.trajectoryContent}}</span>
            <span class="label_item" v-if="item.stayLength">停留时长 {{item.stayLength}} s</span>
            <span class="label_item" v-if="item.browseProgress">进度 {{item.browseProgress}} %</span>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "customerTrail",
  props:['customerTrailList']
}
</script>

<style lang="less" scoped>
.no_data {
  font-size: 14px;
  color: #666;
  line-height: 50px;
  text-align: center;
}
.timeline_box {
  padding-top: 50px;
  display: flex;
  justify-content: center;

  .line_item {
    height: 100px;
    .words_item{
      color: #333;
      font-size: 15px;
      margin-right: 30px;
    }
    .label_item {
      background-color: #E9F5FC;
      font-size: 14px;
      color: #3DA2FB;
      padding: 5px 15px;
      border-radius: 24px;
      margin-right: 12px;
      display: inline-block;
      margin-bottom: 8px;
    }
  }

  .timeline_left {
    width: 25%;
    .line_item {
      text-align: right;
      .time {
        display: inline-block;
        width: 50%;
        padding-right: 30px;
        color: #333;
      }
    }
  }

  .timeline_right {
    position: relative;
    left: -10px;
    width: 85%;
    .line_item{
      //display: flex;
      //justify-content: space-around;
      .things_box{
        width: 70%;
        padding-left: 30px;

      }
      .name_box{
        width: 30%;
        text-align: center;
        line-height: 30px;
        color: #333;
      }
    }
  }
}
</style>